/**
 * Mock data source for the messenger feature.
 * Wraps the static fixtures in `mock-data.ts` so consumers see a typed,
 * async surface. Swap this file (or branch on env) when the real backend
 * lands — `messenger.service.ts` consumers stay unchanged.
 */

import { MOCK_CALLS, MOCK_CONVERSATIONS, MOCK_MESSAGES } from '../mock-data'
import type { CallRecord, Conversation, Message } from '../types'

export const messengerRepo = {
  async listConversations(): Promise<Conversation[]> {
    return MOCK_CONVERSATIONS
  },
  async listCalls(): Promise<CallRecord[]> {
    return MOCK_CALLS
  },
  async getMessages(conversationId: string): Promise<Message[]> {
    return MOCK_MESSAGES[conversationId] ?? []
  },
}
